import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="flex min-h-screen items-center justify-center bg-warm">
        <Loader2 className="animate-spin text-teal" size={32} />
      </div>
    );
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
